const PROJECTS_LIST = [
  {
    id: "1",
    date: "November 02, 2020",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/programmer.png?raw=true",
    title: "Bennett University",
    link: "https://play.google.com/store/apps/details?id=in.edu.bennett.bennettuniversityapp2&hl=en_IN&gl=US",
    description:
      "This is the official app for Bennett University, Greater Noida (UP) INDIA setup by the largest media house in India.",
  },
  {
    id: "2",
    date: "February 13, 2020",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "Be U Salons Hair Deals In Delhi",
    link: "https://play.google.com/store/apps/details?id=com.beusalons.android&hl=en_IN&gl=US",
    description: "All in one beauty solution for you!",
  },
  {
    id: "3",
    date: "November 03, 2020",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "Be U Salons Partner App",
    link: "https://play.google.com/store/apps/details?id=com.employee.app&hl=en_IN&gl=US",
    description:
      "The app enables the owner to see the customers profile, employee profile and all the reports of the salon. The employee can see his/her daily revenue and day wise analysis.",
  },
  {
    id: "4",
    date: "August 17, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "Mihi",
    link: "https://play.google.com/store/apps/details?id=com.mihi.mihimobileapp&hl=en_IN&gl=US",
    description:
      "Mihi is a cloud-based solution for time and attendance, vacation, leave management, and benefits administration for companies with a global workforce.",
  },
  {
    id: "5",
    date: "August 14, 2020",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "Record Book : Excel & Register",
    link: "https://play.google.com/store/apps/details?id=com.foodmonk.rekordapp&hl=en_IN&gl=US",
    description:
      "RecordBook is a Free Digital Register, Excel, Spreadsheet & Tasklist App.",
  },
  {
    id: "6",
    date: "November 20, 2021",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/js.png?raw=true",
    title: "OQ Employee App",
    link: "https://oq.com/en",
    description:
      "A project for managing employees and their staff at OQ Digital,Oman",
  },
  {
    id: "7",
    date: "October 12, 2017",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/programmer.png?raw=true",
    title: "JavaScript (PM Publisher)",
    link: "https://play.google.com/store/apps/details?id=com.pmpublisher.javascript&hl=en&gl=US",
    description: "A ebook project for PM Publisher clients.",
  },
  {
    id: "7",
    date: "July 30, 2020",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/programmer.png?raw=true",
    title: "Saar Books Store",
    link: "https://play.google.com/store/apps/details?id=com.saarbooks.allapps&hl=en_IN&gl=US",
    description: "A book store project for Saar Books Publications Pvt. Ltd",
  },
  {
    id: "8",
    date: "July 30, 2022",
    image:
      "https://github.com/hrusikeshswain/Demo/blob/master/app/programmer.png?raw=true",
    title: "Safeguard Global",
    link: "https://play.google.com/store/apps/details?id=com.globalplus&hl=en_IN&gl=US",
    description: "An EMS service app.",
  },
];

export default PROJECTS_LIST;
